// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import PatientImageExample from './data'

export default function PatientImageExampleFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/PatientImageExample">
      <PatientImageExample {...props}>
        {children}
      </PatientImageExample>
    </Flow>
  )
}
